import { toast } from "@kyan/ui";
import { useState } from "react";

import { useRedeemReferral } from "#/services/referrals/hooks/useRedeemReferral";

interface RefCodeInputControllerOptions {
  onSuccess?: () => void;
}

export const useRefCodeInputController = ({
  onSuccess,
}: RefCodeInputControllerOptions = {}) => {
  const [error, setError] = useState<string | null>(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [refCode, setRefCode] = useState("");
  const { mutate: redeemReferral, isPending } = useRedeemReferral({
    onSuccess: () => {
      toast.success({
        title: "Referral applied",
        description: "Referral confirmed!",
      });
      setIsSuccess(true);
      onSuccess?.();
    },
    onError: (error) => {
      toast.error({ title: "Referral validation", description: error.message });
      setError(error.message);
      setIsSuccess(false);
    },
  });

  const handleApply = () => {
    const code = refCode.trim();

    if (!code) return;

    redeemReferral({ code });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRefCode(e.target.value);
    setError(null);
    setIsSuccess(false);
  };

  return {
    error,
    refCode: refCode.trim(),
    isPending,
    isSuccess,
    handleApply,
    handleInputChange,
  };
};
